import { Controller } from 'stimulus'

export default class extends Controller {
  connect() {
    const element = document.querySelector('#db_logs')
    element.scrollTop = element.scrollHeight
  }
}
